import { QueryKeys, useEntities } from "@/api/core";
import { accountSchema } from "@/schemas";

interface Options {
  isEnabled?: boolean;
}

function useAccountSearch(q: string = "", options: Options = {}) {
  const { isEnabled = true } = options;

  return useEntities({
    queryKey: QueryKeys.accounts.search(q),
    endpoint: "/api/v1/accounts/search",
    params: {
      q,
      limit: 4,
      resolve: true,
    },
    schema: accountSchema,
    enabled: isEnabled && q.length > 0,
  });
}

export { useAccountSearch };
